/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import theme, { Content_Text } from "../Component/theme";

import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import img_seller1 from "../image/live_commerce/img_seller1.png";
import img_seller2_1 from "../image/live_commerce/img_seller2_1.png";
import img_seller2_2 from "../image/live_commerce/img_seller2_2.png";
import img_seller2_3 from "../image/live_commerce/img_seller2_3.png";
import img_seller2_4 from "../image/live_commerce/img_seller2_4.png";
import img_seller3_1 from "../image/live_commerce/img_seller3_1.png";
import img_seller3_2 from "../image/live_commerce/img_seller3_2.png";
import img_seller4 from "../image/live_commerce/img_seller4.png";

import img_Platform_1 from "../image/live_commerce/img_Platform_1.png";
import img_Platform_1_sel from "../image/live_commerce/img_Platform_1_sel.png";
import img_Platform_2 from "../image/live_commerce/img_Platform_2.png";
import img_Platform_2_sel from "../image/live_commerce/img_Platform_2_sel.png";
import img_Platform_3 from "../image/live_commerce/img_Platform_3.png";
import img_Platform_3_sel from "../image/live_commerce/img_Platform_3_sel.png";

import img_Platform_seller_1 from "../image/live_commerce/img_Platform_seller_1.png";
import img_Platform_seller_1_sel from "../image/live_commerce/img_Platform_seller_1_sel.png";
import img_Platform_seller_2 from "../image/live_commerce/img_Platform_seller_2.png";
import img_Platform_seller_2_sel from "../image/live_commerce/img_Platform_seller_2_sel.png";
import img_Platform_seller_3 from "../image/live_commerce/img_Platform_seller_3.png";
import img_Platform_seller_3_sel from "../image/live_commerce/img_Platform_seller_3_sel.png";
import img_Platform_seller_4 from "../image/live_commerce/img_Platform_seller_4.png";
import img_Platform_seller_4_sel from "../image/live_commerce/img_Platform_seller_4_sel.png";

import img_page1 from "../image/live_commerce/img_page1.png";
import img_page2_1 from "../image/live_commerce/img_page2_1.png";
import img_page2_2 from "../image/live_commerce/img_page2_2.png";
import img_page2_3 from "../image/live_commerce/img_page2_3.png";
import img_page2_4 from "../image/live_commerce/img_page2_4.png";
import img_page3_1 from "../image/live_commerce/img_page3_1.png";
import img_page3_2 from "../image/live_commerce/img_page3_2.png";

import ic_사용자 from "../image/live_commerce/ic_사용자.png";
import ic_사용자_sel from "../image/live_commerce/ic_사용자_sel.png";
import ic_셀러 from "../image/live_commerce/ic_셀러.png";
import ic_셀러_sel from "../image/live_commerce/ic_셀러_sel.png";

import Footer_FMS from "./Footer_Live";
import Header_Live from "./Header_Live";
import Side_FMS from "./Side_Live";

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 85px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-color: #f1f1f1;
  border-style: solid;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 10;
  @media (max-width: 800px) {
    padding-left: 15px;
  }
`;

const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 30px;
`;
const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 800px) {
    padding-top: 0px;
  }
`;

const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;
const Main_Content2 = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;
const Main_Content3 = styled.div`
  width: 100%;
  max-width: 700px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Btn_Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
  @media (max-width: 800px) {
    flex: 0;
  }
`;

const Main_Bar = styled.div`
  border-width: 2px 0px 0px 0px;
  border-color: ${theme.colors.bgGray};
  border-style: solid;
  width: 1200px;
  margin-bottom: 30px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;
const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 60px;
  cursor: pointer;
`;

const Image2 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: ${(props) => (props.$large ? "800px" : "500px")};
  margin-bottom: 30px;
  margin-left: ${(props) => (props.$large ? "100px" : 0)};
  border-radius: 8px;

  @media (max-width: 800px) {
    width: ${(props) => (props.$large ? "90%" : "80%")};
    margin-left: ${(props) => (props.$large ? "10%" : 0)};
  }
`;

const Image3 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: ${(props) => (props.$large ? "900px" : "800px")};
  margin-bottom: 30px;
  margin-left: ${(props) => (props.$large ? "100px" : 0)};
  border-radius: 8px;

  @media (max-width: 800px) {
    width: ${(props) => (props.$large ? "90%" : "80%")};
    margin-left: ${(props) => (props.$large ? "10%" : 0)};
  }
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

const Footer_Text = styled(Content_Text)`
  margin-top: 5px;
`;

const Select_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 300px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1200px) {
    padding: 50px 15px 0px 15px;
  }
  @media (max-width: 800px) {
    padding: 0px;
    max-width: 250px;
  }
`;
const Select_div2 = styled.div`
  display: flex;
  width: 100%;
  max-width: 400px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
    max-width: 320px;
  }
`;

const Title_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 5px;
`;
const Image_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const Text_div2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  text-align: center;
  margin-bottom: 50px;
`;

const Platform_Select_div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  @media (max-width: 800px) {
    margin-top: 0px;
    margin-bottom: 30px;
  }
`;

const Platform_Select_Image = styled(Image)`
  width: 200px;
  cursor: pointer;
  margin: 5px;
  @media (max-width: 800px) {
    width: 120px;
  }
`;

function Platform_Live() {
  const navigation = useNavigate();
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const [sel, set_Sel] = useState("01");
  const [select_platform, set_Select_Platform] = useState("사용자");
  const [parking5_type, set_Parking5_Type] = useState("공사원가계산서");
  const [open_menu, set_Open_Menu] = useState(false);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const close_terms = () => set_Terms(false);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // 사이즈 체크
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_Live page={"플랫폼"} />
      </Header>
      <Main>
        <Main_div>
          <Main_init_div>
            <Main_Content>
              <Content_Text $xxlarge $xbold>
                플랫폼
              </Content_Text>
              <Footer_Text>
                기역기역에서 제공하는 라이브커머스 기본 플랫폼입니다.
              </Footer_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div>
        <Platform_Select_div>
          <Platform_Select_Image
            onClick={() => {
              set_Select_Platform("사용자");
              set_Sel("01");
            }}
            src={select_platform === "사용자" ? ic_사용자_sel : ic_사용자}
            alt={ic_사용자}
          />
          <Platform_Select_Image
            onClick={() => {
              set_Select_Platform("셀러");
              set_Sel("01");
            }}
            src={select_platform === "셀러" ? ic_셀러_sel : ic_셀러}
            alt={ic_셀러}
          />
        </Platform_Select_div>
        {select_platform === "사용자" ? (
          <>
            <Main_div>
              <Select_div>
                <Main_Content2>
                  <Btn_Div>
                    <Image
                      onClick={() => {
                        set_Sel("01");
                      }}
                      src={sel === "01" ? img_Platform_1_sel : img_Platform_1}
                      alt={img_Platform_1}
                    />
                    <Content_Text
                      style={{ marginTop: 10 }}
                      $blue2={sel === "01"}
                      $lightGray
                      $small
                      $bold
                    >
                      라이브 홈
                    </Content_Text>
                  </Btn_Div>
                  <Btn_Div>
                    <Image
                      onClick={() => {
                        set_Sel("02");
                      }}
                      src={sel === "02" ? img_Platform_2_sel : img_Platform_2}
                      alt={img_Platform_1}
                    />
                    <Content_Text
                      style={{ marginTop: 10 }}
                      $blue2={sel === "02"}
                      $lightGray
                      $small
                      $bold
                    >
                      라이브 화면
                    </Content_Text>
                  </Btn_Div>
                  <Btn_Div>
                    <Image
                      onClick={() => {
                        set_Sel("03");
                      }}
                      src={sel === "03" ? img_Platform_3_sel : img_Platform_3}
                      alt={img_Platform_1}
                    />
                    <Content_Text
                      style={{ marginTop: 10 }}
                      $blue2={sel === "03"}
                      $lightGray
                      $small
                      $bold
                    >
                      정산서
                    </Content_Text>
                  </Btn_Div>
                </Main_Content2>
              </Select_div>
            </Main_div>

            <Main_div>
              <Main_Bar></Main_Bar>
            </Main_div>
            <Title_div>
              <Content_Text $bold $blue2>
                {sel}
              </Content_Text>
            </Title_div>
            <Title_div style={{ marginBottom: 15 }}>
              <Content_Text $xlarge $xbold>
                {sel === "01"
                  ? "라이브 홈"
                  : sel === "02"
                  ? "라이브 화면"
                  : "정산서"}
              </Content_Text>
            </Title_div>
            {sel === "01" ? (
              <>
                <Text_div2>
                  <Content_Text $gray>
                    현재 진행중인 라이브와 예약된 라이브를 확인할 수 있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image2 src={img_page1} alt={img_page1} />
                </Image_div2>
              </>
            ) : sel === "02" ? (
              <>
                <Text_div2>
                  <Content_Text $gray>
                    셀러와 소통을 하고 원하는 상품을 구매할 수 있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image2 src={img_page2_1} alt={img_page2_1} />
                </Image_div2>
                <Image_div2>
                  <Image2 src={img_page2_2} alt={img_page2_2} />
                </Image_div2>
                <Image_div2>
                  <Image2 src={img_page2_3} alt={img_page2_3} />
                </Image_div2>
                <Image_div2>
                  <Image2 src={img_page2_4} alt={img_page2_4} />
                </Image_div2>
              </>
            ) : (
              <>
                <Text_div2>
                  <Content_Text $gray>
                    카카오 알림톡으로 정산서를 받을 수 있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image2 src={img_page3_1} alt={img_page3_1} />
                </Image_div2>
                <Image_div2>
                  <Image2 src={img_page3_2} alt={img_page3_2} />
                </Image_div2>
              </>
            )}
          </>
        ) : (
          <>
            <Main_div>
              <Select_div2>
                <Main_Content3>
                  <Btn_Div>
                    <Image
                      onClick={() => {
                        set_Sel("01");
                      }}
                      src={
                        sel === "01"
                          ? img_Platform_seller_1_sel
                          : img_Platform_seller_1
                      }
                      alt={img_Platform_1}
                    />
                    <Content_Text
                      style={{ marginTop: 10 }}
                      $blue2={sel === "01"}
                      $lightGray
                      $small
                      $bold
                    >
                      대시보드
                    </Content_Text>
                  </Btn_Div>
                  <Btn_Div>
                    <Image
                      onClick={() => {
                        set_Sel("02");
                      }}
                      src={
                        sel === "02"
                          ? img_Platform_seller_2_sel
                          : img_Platform_seller_2
                      }
                      alt={img_Platform_1}
                    />
                    <Content_Text
                      style={{ marginTop: 10 }}
                      $blue2={sel === "02"}
                      $lightGray
                      $small
                      $bold
                    >
                      라이브 목록
                    </Content_Text>
                  </Btn_Div>
                  <Btn_Div>
                    <Image
                      onClick={() => {
                        set_Sel("03");
                      }}
                      src={
                        sel === "03"
                          ? img_Platform_seller_3_sel
                          : img_Platform_seller_3
                      }
                      alt={img_Platform_1}
                    />
                    <Content_Text
                      style={{ marginTop: 10 }}
                      $blue2={sel === "03"}
                      $lightGray
                      $small
                      $bold
                    >
                      주문내역
                    </Content_Text>
                  </Btn_Div>
                  <Btn_Div>
                    <Image
                      onClick={() => {
                        set_Sel("04");
                      }}
                      src={
                        sel === "04"
                          ? img_Platform_seller_4_sel
                          : img_Platform_seller_4
                      }
                      alt={img_Platform_1}
                    />
                    <Content_Text
                      style={{ marginTop: 10 }}
                      $blue2={sel === "04"}
                      $lightGray
                      $small
                      $bold
                    >
                      회원목록
                    </Content_Text>
                  </Btn_Div>
                </Main_Content3>
              </Select_div2>
            </Main_div>
            <Main_div>
              <Main_Bar></Main_Bar>
            </Main_div>
            <Title_div>
              <Content_Text $bold $blue2>
                {sel}
              </Content_Text>
            </Title_div>
            <Title_div style={{ marginBottom: 15 }}>
              <Content_Text $xlarge $xbold>
                {sel === "01"
                  ? "대시보드"
                  : sel === "02"
                  ? "라이브 목록"
                  : sel === "03"
                  ? "주문내역"
                  : "회원목록"}
              </Content_Text>
            </Title_div>
            {sel === "01" ? (
              <>
                <Text_div2>
                  <Content_Text $gray>
                    당월 매출 현황 및 주문/배송 상태를 확인할 수 있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image3 src={img_seller1} alt={img_seller1} />
                </Image_div2>
              </>
            ) : sel === "02" ? (
              <>
                <Text_div2>
                  <Content_Text $gray>
                    관리가 필요한 주차장을 등록하고 라이브 목록에 필요한 정보를
                    입력할 수 있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image3 src={img_seller2_1} alt={img_seller2_1} />
                </Image_div2>
                <Image_div2>
                  <Image3 src={img_seller2_2} alt={img_seller2_2} />
                </Image_div2>
                <Image_div2>
                  <Image3 src={img_seller2_3} alt={img_seller2_3} />
                </Image_div2>
                <Image_div2>
                  <Image3 src={img_seller2_4} alt={img_seller2_4} />
                </Image_div2>
              </>
            ) : sel === "03" ? (
              <>
                <Text_div2>
                  <Content_Text $gray>
                    주문내역들을 상태변경으로 관리할 수 있으며, 엑셀 다운로드를
                    할 수 있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image3 src={img_seller3_1} alt={img_seller3_1} />
                </Image_div2>
                <Image_div2>
                  <Image3 src={img_seller3_2} alt={img_seller3_2} />
                </Image_div2>
              </>
            ) : (
              <>
                <Text_div2>
                  <Content_Text $gray>
                    회원 및 블랙리스트를 관리할 수 있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image3 src={img_seller4} alt={img_seller4} />
                </Image_div2>
              </>
            )}
          </>
        )}
        <Side_FMS width={windowSize.width} />
      </Main>
      <Footer>
        <Footer_FMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
    </Container>
  );
}

export default Platform_Live;
